import * as React from 'react';

import { JRCButton } from 'index';
import { JRCFileViewerOpenWithOptionType } from './types';
import { JRCFileViewerOpenWithOptions } from './JRCFileViewerOpenWithOptions';

import {
    CSSFileViewerApplicationContentWrapper,
    CSSFileViewerApplicationContent,
    CSSFileViewerOptions,
} from './JRCFileViewer.styles';
import { useIntl } from 'react-intl';
import { jFileLittle } from 'jamespot-user-api';

type JRCFileViewerContentApplicationProps = {
    file?: jFileLittle;
    options?: JRCFileViewerOpenWithOptionType[];
    children: React.ReactNode;
};

export const JRCFileViewerContentApplication = ({ file, options, children }: JRCFileViewerContentApplicationProps) => {
    const intl = useIntl();
    return (
        <CSSFileViewerApplicationContent>
            <CSSFileViewerApplicationContentWrapper>{children}</CSSFileViewerApplicationContentWrapper>
            {file !== undefined ? (
                <CSSFileViewerOptions>
                    <JRCButton
                        label={intl.formatMessage({ id: 'GLOBAL_Download' })}
                        onClick={() => {
                            // THIS METHODE EXISTS IN CORE. BUT CANNOT ACCESS CORE FROM COMPONENTS
                            const link = document.createElement('a');
                            link.href = `/downloadFile.php?id=${file.id}`;
                            link.click();
                            link.remove();
                            return;
                        }}
                    />
                    {options !== undefined && file !== undefined && (
                        <JRCFileViewerOpenWithOptions file={file} options={options} />
                    )}
                </CSSFileViewerOptions>
            ) : (
                <></>
            )}
        </CSSFileViewerApplicationContent>
    );
};
